/* assets/artist-application.js
   Seven Tattoo — Artist Application
*/
(() => {
  const section = document.querySelector('section.aa-page[id^="aa-"]');
  const form    = section?.querySelector('#aaForm');
  if (!form) return;

  const btn    = section.querySelector('#aaSubmit');
  const okBox  = section.querySelector('#aaSuccess');
  const errBox = section.querySelector('#aaError');

  const endpoint    = (form.dataset.endpoint || section.dataset.endpoint || '').trim();
  const notifyEmail = (form.dataset.notifyEmail || '').trim();

  const show    = el => el && el.removeAttribute('hidden');
  const hide    = el => el && el.setAttribute('hidden', '');
  const disable = el => { if (el) { el.disabled = true;  el.setAttribute('aria-busy', 'true'); } };
  const enable  = el => { if (el) { el.disabled = false; el.removeAttribute('aria-busy'); } };

  // Honeypot
  const hp = form.querySelector('input[name="hp_extra_info"]');
  if (hp) {
    hp.value = '';
    hp.setAttribute('autocomplete', 'off');
    hp.setAttribute('tabindex', '-1');
    hp.style.position = 'absolute';
    hp.style.left = '-9999px';
  }

  // Other lane toggle
  const otherRadio = form.querySelector('input[name="primary_lane"][value="Other"]');
  const otherInput = form.querySelector('.aa-other-input');
  if (otherRadio && otherInput) {
    const sync = () => {
      otherInput.disabled = !otherRadio.checked;
      if (!otherRadio.checked) otherInput.value = '';
    };
    form.querySelectorAll('input[name="primary_lane"]').forEach(r => r.addEventListener('change', sync));
    sync();
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    hide(okBox); hide(errBox);

    if (!endpoint || !/^https?:\/\//i.test(endpoint)) {
      show(errBox);
      errBox.innerHTML = '<strong>Oops.</strong> Form endpoint is not configured.';
      return;
    }

    // Honeypot check
    if (hp && hp.value.trim()) { show(okBox); return; }

    // Validate primary lane
    const laneSelected = form.querySelector('input[name="primary_lane"]:checked');
    if (!laneSelected) {
      show(errBox);
      errBox.innerHTML = '<strong>Oops.</strong> Please select your primary lane.';
      form.querySelector('input[name="primary_lane"]')?.focus();
      return;
    }
    if (laneSelected.value === 'Other' && otherInput && !otherInput.value.trim()) {
      show(errBox);
      errBox.innerHTML = '<strong>Oops.</strong> Please describe your lane.';
      otherInput.focus();
      return;
    }

    // Validate minimum 3 healed photos
    const photo1 = (form.querySelector('[name="healed_photo_1"]')?.value || '').trim();
    const photo2 = (form.querySelector('[name="healed_photo_2"]')?.value || '').trim();
    const photo3 = (form.querySelector('[name="healed_photo_3"]')?.value || '').trim();
    if (!photo1 || !photo2 || !photo3) {
      show(errBox);
      errBox.innerHTML = '<strong>Oops.</strong> Please provide at least 3 healed work photo links.';
      form.querySelector('[name="healed_photo_1"]')?.focus();
      return;
    }

    if (!form.reportValidity()) return;

    const laneValue = laneSelected.value === 'Other'
      ? `Other: ${otherInput.value.trim()}`
      : laneSelected.value;

    const fd = new FormData(form);
    const payload = {
      name:             String(fd.get('name')            || '').trim(),
      phone:            String(fd.get('phone')           || '').trim(),
      email:            String(fd.get('email')           || '').trim(),
      location:         String(fd.get('location')        || '').trim(),
      ig_handle:        String(fd.get('ig_handle')       || '').trim(),
      primary_lane:     laneValue,
      healed_photo_1:   String(fd.get('healed_photo_1')  || '').trim(),
      healed_photo_2:   String(fd.get('healed_photo_2')  || '').trim(),
      healed_photo_3:   String(fd.get('healed_photo_3')  || '').trim(),
      healed_photo_4:   String(fd.get('healed_photo_4')  || '').trim(),
      healed_photo_5:   String(fd.get('healed_photo_5')  || '').trim(),
      q_proud:          String(fd.get('q_proud')         || '').trim(),
      q_commitment:     String(fd.get('q_commitment')    || '').trim(),
      q_feel:           String(fd.get('q_feel')          || '').trim(),
      agree_sanitation: !!fd.get('agree_sanitation'),
      video_url:        String(fd.get('video_url')       || '').trim(),
      hp_extra_info:    String(fd.get('hp_extra_info')   || '').trim(),
    };

    if (notifyEmail) payload.notify_email = notifyEmail;
    if (payload.hp_extra_info) { show(okBox); return; }

    disable(btn);

    try {
      const res  = await fetch(endpoint, {
        method: 'POST', mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        redirect: 'follow', cache: 'no-store',
      });
      const text = await res.text();
      let data;
      try { data = JSON.parse(text); } catch { data = { ok: false, error: 'Invalid JSON from server' }; }

      if (res.ok && data && data.ok) {
        show(okBox);
        form.reset();
        if (otherInput) otherInput.disabled = true;
      } else {
        show(errBox);
        errBox.innerHTML = `<strong>Oops.</strong> ${data?.error || 'Submission failed. Try again.'}`;
      }
    } catch (err) {
      console.error('[Artist] network error', err);
      show(errBox);
      errBox.innerHTML = '<strong>Oops.</strong> Network error. Try again.';
    } finally {
      enable(btn);
    }
  });
})();